import pressData from '../../common/models/pressData';
import { Fragment } from 'react';
import PressCell from './PressCell';
import VerticalSpacer from '../VerticalSpacer/VerticalSpacer';
import React from 'react';
import PropTypes from 'prop-types';

const PressArticles = ({ isDesktop }) => (
  <Fragment>
    {pressData.map(el => (
      <div key={el.url}>
        <PressCell
          isDesktop={isDesktop}
          articleTitle={el.articleTitle}
          author={el.author}
          country={el.country}
          dateString={el.dateString}
          url={el.url}
        />
        <VerticalSpacer height={isDesktop ? '60px' : '40px'} />
      </div>
    ))}
  </Fragment>
);

PressArticles.defaultProps = {
  isDesktop: false
};

PressArticles.propTypes = {
  isDesktop: PropTypes.bool
};

export default PressArticles;
